export default {
  data() {
      return {
        menuItem: [],
      }
  },
  created() {
      this.makeMenu(this.$router.options.routes, this.menuItem)
  },
  methods: {
    makeMenu(list, inputMenu, parentPath=null) {
        list.forEach((depth, index) => {
            if(depth.meta.sideHidden) {
                return;
            }
            let obj = {
                title: depth.meta.sideName,
                icon: depth.meta.icon_name
            }
            let path = parentPath? `${depth.path === "" ? parentPath : parentPath+'/'+depth.path}` : depth.path
            if(depth.hasOwnProperty('children') && depth.children.filter(child => !child.meta.sideHidden).length > 0) {
                if(!obj.hasOwnProperty('child')) {
                    obj.child = [];
                }
                inputMenu.push(obj)
                this.makeMenu(depth.children, obj.child, path)
            }else{
                obj.href = path; 
                inputMenu.push(obj)
            }
        });
    }
  },
}